module.exports = __webpack_public_path__ + "static/media/email.d651bd0b.png";